import "./Ktmc.css";
import Header from "./Header";
import Footer from "./Footer";
import CountUp from "react-countup";
import { useState } from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function KtmcPage() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.ktmc;

  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <div>
        <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
<!-- Header Start --> */}
      <div class="container-fluid Ktmcpage bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Excellence in Every Endeavor!
          </h4>
        </div>
      </div>
      {/* <!-- Header End -->

<!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      {/* <!-- About Start --> */}
      <div class="container-fluid about overflow-hidden py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-xl-12 m-auto wow fadeInRight" data-wow-delay="0.2s">
              <div class="about-item text-center">
                <h1 class="mb-4 pt-5 text-white">
                  Kovai Tech Members Chamber{" "}
                </h1>
                <p class="text-white">
                  {" "}
                  KTMC (Kovai Tech Members Chamber) is a premium business
                  networking hub that promotes collaboration and growth among
                  industry leaders. With advanced facilities and expert-led
                  initiatives, it fosters innovation, knowledge exchange, and
                  business development across various sectors. Through its
                  dynamic platform, KTMC connects professionals, entrepreneurs,
                  and organizations, enabling them to share ideas, build
                  strategic partnerships, and unlock new opportunities. KTMC is
                  dedicated to empowering businesses to thrive in an
                  ever-evolving market by nurturing a collaborative environment
                  and ensuring long-term success and impact.
                </p>
                <p class="text-white">
                  {" "}
                  Through its dynamic platform, KTMC connects professionals,
                  entrepreneurs, and organizations, enabling them to share
                  ideas, build strategic partnerships, and unlock new
                  opportunities. KTMC is dedicated to empowering businesses to
                  thrive in an ever-evolving market by nurturing a collaborative
                  environment and ensuring long-term success and impact.
                </p>
              </div>

              <div class="row mt-5 about-ktmc-events g-4 justify-content-center">
                <div class="col-lg-6 col-xl-4">
                  <div class="blog-itemss image-slide-right-to-center">
                    <div class="blog-imgs">
                      <img
                        src="assets/img/event/ev1.jpg"
                        class="img-fluid rounded-top w-100"
                        alt="event"
                      />
                      <div class="blog-date py-2" style={{ fontSize: "10px" }}>
                        <i class="fa fa-calendar-alt me-1"></i> 16 November 2024
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4">
                  <div class="blog-itemss image-slide-right-to-center">
                    <div class="blog-imgs">
                      <img
                        src="assets/img/event/ev2.jpg"
                        class="img-fluid rounded-top w-100"
                        alt="event"
                      />
                      <div class="blog-date py-2" style={{ fontSize: "10px" }}>
                        <i class="fa fa-calendar-alt me-1"></i> 16 November 2024
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4">
                  <div class="blog-itemss image-slide-right-to-center">
                    <div class="blog-imgs">
                      <img
                        src="assets/img/event/ev4.jpg"
                        class="img-fluid rounded-top w-100"
                        alt="event"
                      />
                      <div class="blog-date py-2" style={{ fontSize: "10px" }}>
                        <i class="fa fa-calendar-alt me-1"></i> 16 November 2024
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}
      <div className="mobile pb-5">
        <div class="container-fluid mt-5 mb-5 service bg-light overflow-hidden p-0">
          <div class="clientslide  wow fadeInUp">
            <div class="row p-0">
              <div class="slider">
                <div class="slide-track">
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/crescent logo.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/AIIRMYCART.png"
                        height="100"
                        width="250"
                        alt="evclientlogoent"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/edilink.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/DFLv3.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/srbt.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/logo_dark.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/logoa-1.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/mz account.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/Nantech - Logo.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/TK MART LOGO.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/NENE LOGO PNG.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/VK Logo PNG.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/royal shelter.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                  <div class="slide">
                    <div class="slide_itemlist">
                      <img
                        src="assets/img/clients/nouveaux.png"
                        height="100"
                        width="250"
                        alt="clientlogo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default KtmcPage;
